import CryptoJS from 'crypto-js';
export const generateIv = () => {
	const iv = CryptoJS.lib.WordArray.random(16);
	const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
	return ivBase64;
};

export const encryptGlobal = (value, iv) => {
	const secretKey = CryptoJS.enc.Utf8.parse(
		process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT_PASS
	);
	const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey, {
		iv: CryptoJS.enc.Base64.parse(iv),
		padding: CryptoJS.pad.Pkcs7,
		mode: CryptoJS.mode.CBC,
	});

	return encrypted.toString();
};

export const decryptGlobal = (ciphertext, iv) => {
	const secretKey = CryptoJS.enc.Utf8.parse(
		process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT_PASS
	);

	const decrypted = CryptoJS.AES.decrypt(ciphertext, secretKey, {
		iv: CryptoJS.enc.Base64.parse(iv),
		padding: CryptoJS.pad.Pkcs7,
		mode: CryptoJS.mode.CBC,
	});
	const result = decrypted.toString(CryptoJS.enc.Utf8);
	try {
		return JSON.parse(result);
	} catch {
		return result;
	}
};
